import { render, staticRenderFns } from "./BotSidebar.vue?vue&type=template&id=4a3293b4"
import script from "./BotSidebar.vue?vue&type=script&lang=js"
export * from "./BotSidebar.vue?vue&type=script&lang=js"
import style0 from "./BotSidebar.vue?vue&type=style&index=0&id=4a3293b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports